import _isEqual from 'lodash/isEqual';
import _pick from 'lodash/pick';

import storageKeys from '@syndicated-wallet/constants/storageKeys';

export default function isWalletUpdated(prev = {}, next = {}, checkLoad = false) {
    // diffs(prev, next);

    if (checkLoad && !prev.isPaymentsInfoLoaded && next.isPaymentsInfoLoaded) {
        return 'firstLoad';
    }
    if (!_isEqual(_pick(prev, storageKeys), _pick(next, storageKeys))) {
        return 'data';
    }
    if (checkLoad && prev.isPaymentsInfoLoaded !== next.isPaymentsInfoLoaded) {
        // TODO: can this be a valid case
        return 'ui';
    }
    if (!_isEqual(prev.interactions?.syncAlert, next.interactions?.syncAlert)) {
        return 'ui';
    }
    return '';
}
